import { createI18n } from 'vue-i18n'
import tr from './locales/tr.json'

const messages = {
  tr: tr,
}

export default createI18n({
  legacy: false,
  locale: 'tr',
  fallbackLocale: 'tr',
  messages,
})
